import actionsApi from "../../api/actionsApi";

const state = { actions: [] };

const actions = {
    createAction({ commit }, action) {
        return new Promise((resolve, reject) => {
            actionsApi
                .store(action)
                .then((response) => {
                    if (response.status === 201) {
                        commit("ADD_ACTION", response.data.actionCreated);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    updateAction({ commit }, data) {
        return new Promise((resolve, reject) => {
            actionsApi
                .update(data)
                .then((response) => {
                    if (response.status === 200) {
                        commit("UPDATE_ACTION", response.data.actionUpdated);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getActions({ commit }) {
        return new Promise((resolve, reject) => {
            actionsApi
                .get()
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_ACTION", response.data.actions);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    deleteAction({ commit }, actionId) {
        return new Promise((resolve, reject) => {
            actionsApi
                .delete(actionId)
                .then((response) => {
                    if (response.status === 200) {
                        commit("DELETE_ACTION", actionId);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);

                });
        });
    },
};

const mutations = {
    ADD_ACTION: (state, action) => state.actions.unshift(action),
    SET_ACTION: (state, actions) => (state.actions = actions),
    UPDATE_ACTION: (state, action) => {
        const index = state.actions.findIndex(
            (action) => action.id === action.id
        );
        if (index !== -1) {
            state.actions.splice(index, 1, action);
        }
    },
    DELETE_ACTION: (state, actionID) => {
        state.actions = state.actions.filter(
            (action) => action.id !== actionID
        );
    }
};
export default { state, actions, mutations };